(() => {
  const filter = document.querySelector('[data-journal-filter]');
  if (!filter) return;
  const input = filter.querySelector('input[type="search"]');
  const buttons = [...filter.querySelectorAll('[data-filter]')];
  const posts = [...document.querySelectorAll('[data-post-list] [data-post]')];
  const count = document.querySelector('[data-result-count]');
  const empty = document.querySelector('[data-empty]');
  let active = 'all';
  function update(sync = true) {
    const query = input.value.trim().toLocaleLowerCase('de');
    let found = 0;
    posts.forEach(post => {
      const match = (active === 'all' || post.dataset.category === active) && post.textContent.toLocaleLowerCase('de').includes(query);
      post.hidden = !match;
      if (match) found++;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.filter === active)));
    count.textContent = `${found} ${found === 1 ? 'Beitrag' : 'Beiträge'}`;
    empty.hidden = found !== 0;
    if (sync) {
      const url = new URL(window.location.href);
      if (query) url.searchParams.set('q',input.value.trim()); else url.searchParams.delete('q');
      if (active !== 'all') url.searchParams.set('thema',active); else url.searchParams.delete('thema');
      history.replaceState(null,'',url);
    }
  }
  function fromLocation() {
    const params = new URLSearchParams(window.location.search);
    input.value = params.get('q') || '';
    const requested = params.get('thema');
    active = buttons.some(b => b.dataset.filter === requested) ? requested : 'all';
    update(false);
  }
  buttons.forEach(button => button.addEventListener('click',() => {active=button.dataset.filter; update();}));
  input.addEventListener('input',()=>update());
  filter.addEventListener('submit',event=>{event.preventDefault();update();});
  window.addEventListener('popstate',fromLocation);
  fromLocation();
})();

(() => {
  const drawer = document.querySelector('#FinxfulCartDrawer');
  if (!drawer || !drawer.showModal) return;
  const cartUrl = drawer.dataset.cartUrl;
  const sectionId = drawer.dataset.sectionId;
  const sectionUrl = cartUrl.replace(/cart$/, '');
  const status = drawer.querySelector('[data-cart-status]');
  const cartContent = drawer.querySelector('[data-cart-content]');
  let busy = false;
  let opener;
  let oldOverflow = '';
  function show(source) {
    if (drawer.open) return;
    opener = source || document.activeElement;
    oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    drawer.showModal();
    drawer.querySelector('[data-cart-close]').focus();
  }
  function close() {
    drawer.close();
  }
  drawer.addEventListener('close', () => {
    document.body.style.overflow = oldOverflow;
    opener?.focus();
  });
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-cart-close]')) close();
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) close();
    }
  });
  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-cart-remove], [data-cart-quantity], [name="checkout"]').forEach(node => { node.disabled = value; });
    status.textContent = value ? drawer.dataset.cartLoading : '';
  }
  function render(html) {
    if (!html) throw new Error('Missing cart section');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const updated = doc.querySelector('[data-cart-content]');
    if (!updated) throw new Error('Missing cart content');
    cartContent.replaceChildren(...updated.childNodes);
    const count = doc.querySelector('[data-cart-count]');
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      node.textContent = count?.textContent || '0';
      node.hidden = !count || count.hidden;
    });
  }
  async function refresh() {
    const response = await fetch(`${sectionUrl}?sections=${encodeURIComponent(sectionId)}`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart refresh failed');
    const data = await response.json();
    render(data[sectionId]);
  }
  async function open(source) {
    show(source);
    if (busy) return;
    setBusy(true);
    try { await refresh(); setBusy(false); }
    catch { setBusy(false); status.textContent = drawer.dataset.cartError; }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a.cart-link');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    open(link);
  });
  async function change(key, quantity, focusQuantity) {
    if (busy) return;
    setBusy(true);
    try {
      const response = await fetch(`${cartUrl}/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: [sectionId], sections_url: sectionUrl }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.cartError);
      if (data.sections?.[sectionId]) render(data.sections[sectionId]); else await refresh();
      setBusy(false);
      const target = focusQuantity ? [...drawer.querySelectorAll('[data-cart-quantity]')].find(input => input.dataset.key === key) : null;
      (target || drawer.querySelector('[data-cart-close]')).focus();
    } catch (error) {
      try { await refresh(); } catch {}
      setBusy(false);
      status.textContent = error.message || drawer.dataset.cartError;
    }
  }
  drawer.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-remove]');
    if (button) change(button.dataset.key, 0, false);
  });
  drawer.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    if (!input.reportValidity()) return;
    change(input.dataset.key, Number(input.value), true);
  });
  function isProductForm(form) {
    return form instanceof HTMLFormElement && new URL(form.action, location.origin).pathname.endsWith('/cart/add');
  }
  async function addProduct(form, button) {
    if (busy || !form.reportValidity()) return;
    const body = new FormData(form);
    body.delete('return_to');
    body.append('sections', sectionId);
    body.append('sections_url', sectionUrl);
    setBusy(true);
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${cartUrl}/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.cartError);
      if (data.sections?.[sectionId]) render(data.sections[sectionId]); else await refresh();
      setBusy(false);
      show(button);
    } catch (error) {
      try { await refresh(); } catch {}
      setBusy(false);
      show(button);
      status.textContent = error.message || drawer.dataset.cartError;
    } finally { if (button) button.disabled = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button, input[type="submit"]');
    const form = button?.form;
    if (!button || button.type !== 'submit' || !isProductForm(form)) return;
    event.preventDefault();
    addProduct(form, button);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.isComposing || event.ctrlKey || event.altKey || event.metaKey) return;
    const target = event.target;
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLButtonElement)) return;
    const form = target.form;
    if (!isProductForm(form)) return;
    event.preventDefault();
    const button = target instanceof HTMLButtonElement && target.type === 'submit' ? target : form.querySelector('button[type="submit"], input[type="submit"]');
    addProduct(form, button);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!isProductForm(form)) return;
    event.preventDefault();
    addProduct(form, event.submitter);
  });
  const language = document.querySelector('.fx-language');
  document.addEventListener('click', event => { if (language && !language.contains(event.target)) language.open = false; });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && language?.open) { language.open = false; language.querySelector('summary').focus(); } });
})();
